module.exports = __webpack_public_path__ + "img/img11.4cdcc824.svg";